import { Navigate, useLocation } from 'react-router-dom';
import { useSuperAdminStore } from '../stores/superAdminStore';

export default function SuperAdminProtectedRoute({ children }) {
  const isAuthenticated = useSuperAdminStore((s) => s.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/super-admin/login" state={{ from: location }} replace />;
  }

  return children;
}
